import * as PARAMETERS from '../constants/config/parameters';
/**
 * @name match
 * @function
 * @description Compares the values of 2 arrays to see if they match
 * @param {array} ary1 
 * @param {array} ary2 
 * @returns {boolean} `true` if arrays contain the same values, `false` if they do not
 */
export const match = ( ary1, ary2 ) => {
        
    if( ary1.length !== ary2.length ) return false;

    for( let i = 0; i < ary1.length; i++ ){

        // compare children if nested array
        if( ary1[ i ] instanceof Array && ary2[i] instanceof Array ){
            if( !match( ary1[ i ], ary2[ i ] ) ) return false;

        // otherwise compare values
        } else if ( ary1[ i ] !== ary2[ i ] ){ 
            return false;   
        }           
    } 

    return true;
}

/**
 * @name sortNewest
 * @function
 * @param {array} data - data to be sorted
 * @description sorts provided data by newest creation date
 */
 
 export const sortNewest = data => data.sort(( a, b ) => {    
  let date = a[ PARAMETERS.SORT_BY_DATE ]?.displayValue.localeCompare( b[ PARAMETERS.SORT_BY_DATE ]?.displayValue, 'kn' ),
  name = a[ PARAMETERS.PART_META ].displayValue.localeCompare( b[ PARAMETERS.PART_META ].displayValue, 'co' ),
  data1 = a[ PARAMETERS.PUBLISH_DATE ]?.displayValue.toLowerCase(),
  data2 = b[ PARAMETERS.PUBLISH_DATE ]?.displayValue.toLowerCase();
  
  // sort by flagged new
  if( data1 !== 'yes' && data2 === 'yes' ) return 1;
  if( data1 === 'yes' && data2 !== 'yes' ) return -1;
  
  //sort by publish date
  if( a[PARAMETERS.SORT_BY_DATE] && b[PARAMETERS.SORT_BY_DATE]  && date !== 0 ) return -date;

  //sort by name
  return name;
}
);

/**
 * @name sortOldest
 * @function
 * @param {array} data - data to be sorted
 * @description sorts provided data by oldest creation date
 */

export const sortOldest = data => data.sort((a, b) => {
let date = a[PARAMETERS.SORT_BY_DATE]?.displayValue.localeCompare(b[PARAMETERS.SORT_BY_DATE]?.displayValue, 'kn'),
  name = a[PARAMETERS.PART_META].displayValue.localeCompare(b[PARAMETERS.PART_META].displayValue, 'co'),
  data1 = a[PARAMETERS.PUBLISH_DATE]?.displayValue.toLowerCase(),
  data2 = b[PARAMETERS.PUBLISH_DATE]?.displayValue.toLowerCase();

if (data1 !== 'yes' && data2 === 'yes') return -1;  
if (data1 === 'yes' && data2 !== 'yes') return 1;  

if (a[PARAMETERS.SORT_BY_DATE] && b[PARAMETERS.SORT_BY_DATE]  && date !== 0) return date;  

return name;
});